module.exports = __webpack_public_path__ + "static/media/button_threedots.a6b88c8e.svg";